import styled from 'styled-components';
import { TabText } from '../../styles/button.style';

export const CargoTempLogTabText = styled(TabText)`
    min-width: 6rem;
    font-size: 0.8rem;
    justify-content: center;
    margin: 0;
`;
